module.exports = __webpack_public_path__ + "static/landing-image-01-debb9cdfb851c2805b50ee6bbf7e8706.png";